import(/* webpackMode: "eager" */ "/home/crazysal/sit-a/bd-mobile-next/app/(main)/article/warranty/page.tsx");
